export default "__VITE_ASSET__DT_Uz1e0__"